import { z } from 'zod';

export const BrandConfigSchema = z.object({
  name: z.object({
    full: z.string().min(1),
    short: z.string().min(1),
    tagline_en: z.string(),
    tagline_ar: z.string(),
  }),
  domain: z.string().min(1),
  favicon: z.string().min(1),
  ogImage: z.string().min(1),
  wordmark: z.object({
    short: z.string().min(1),
    full: z.string().min(1),
  }),
  mark: z.string().min(1),
  primaryColor: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, 'primaryColor must be a 6-digit hex'),
  fonts: z.object({
    sans: z.string().min(1),
    sansArabic: z.string().min(1),
    mono: z.string().min(1),
  }),
});

export type BrandConfig = z.infer<typeof BrandConfigSchema>;

export class BrandConfigError extends Error {
  override readonly name = 'BrandConfigError';
}
